
;
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-pwftyzaqw2f';
                    document.querySelectorAll('.ecom-pwftyzaqw2f').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-description-height)",i.style.display="none",t.style.display=""}))
                    
                    });
                    const settings = {};
                    const ID = 'ecom-xs6j6j39uzj';
                    document.querySelectorAll('.ecom-xs6j6j39uzj').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-8xs7gxbr7op';
                    document.querySelectorAll('.ecom-8xs7gxbr7op').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-4vtwsvm5oc6';
                    document.querySelectorAll('.ecom-4vtwsvm5oc6').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            